import {Pipe, PipeTransform} from '@angular/core';
import {HcPair} from './models/hcpair';

@Pipe({
    name: 'limit'
})
export class LimitPipe implements PipeTransform {
    transform(items: HcPair[], limit: number): HcPair[] {
        if (!items || !limit) {
            return items;
        }
        const date = new Date().toISOString().slice(0, 10);
        for (let i = 0; i < items.length; ++i) {
            if (items[i].date >= date) {
                items.splice(i, 1);
            }
        }
        return items.slice(0, limit);
    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/limit.pipe.ts